import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, Inject } from '@angular/core';
import { Project, Mote, MoteType, MediaType } from '../../models';
import { AutoSubOnDestroy, AutoSub, MoteService } from '../../providers';
import { Animations } from '../../animations';

export interface WorldEvent { world: Project, ele: ElementRef };
export interface CollectionEvent { world: Project, collection: Mote };

@AutoSubOnDestroy()
@Component({
    selector: 'mini-world',
    templateUrl: './mini-world.component.html',
    styleUrls: ['./mini-world.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.fadeIn()]
})
export class MiniWorldComponent implements OnInit, AfterViewInit {

    public swiperIndex: number = 0;
    public videoToPlay: string = null;

    public MediaType = MediaType;

    // Input world to be shown
    @Input() set worldInput(world: Project) {
        this.world = world;
        if(!this.world) return;
        // Subescribe to collections (motes) of this world
        AutoSub(this).reg['motesSub'] = this.moteService.watchProjectMotes([world.key]).subscribe(motes => {
            this.collections = motes.filter(mote => mote.canHaveChildren());
            this.cd.detectChanges();
        });
    }

    // Two way binding to opened key
    @Input() showDetails: boolean = false;
    @Output() showDetailsChange = new EventEmitter<boolean>();

    // Two way binding to opened key
    @Input() set openedKey(openedKey: string) {
        // Close this world if another was selected
        if(this.world && this.world.key != openedKey) {
            this.closeWorld();
        }
    }
    // Two way binding to opened key
    @Output() openedKeyChange = new EventEmitter<string>();

    // Output events
    @Output() worldOpened = new EventEmitter<WorldEvent>();
    @Output() loadWorld = new EventEmitter<CollectionEvent>();
    @Output() playTrailer = new EventEmitter<CollectionEvent>();

    @ViewChild('worldContainer', { static: true }) worldContainer: ElementRef;
    @ViewChild('worldContent') worldContent: ElementRef;

    public world: Project = null;
    public hideImageLoader = false;

    public worldHeight = 0;
    public worldWidth = 0;
    public worldMinHeight = 0;

    public collections: Mote[] = [];

    public trailerWatched = false;

    private MAX_SENTENCES = 6;
    public maxTextSentences = this.MAX_SENTENCES;

    constructor(
        private cd: ChangeDetectorRef,
        private moteService: MoteService
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        // Set width and height of world according to screen width and image aspect ratio
        this.worldWidth = this.worldContainer.nativeElement.offsetWidth;
        this.worldHeight = this.worldWidth * (9 / 16);
        // Set minimum world size to initial calculated image height
        this.worldMinHeight = this.worldHeight;
    }

    public toggleOpen() {
        if(this.showDetails) this.closeWorld();
        else this.openWorld();
    }

    public openWorld() {
        // Show details
        this.showDetails = !this.showDetails;
        if(!this.showDetails) return;
        this.openedKeyChange.emit(this.world.key);
        this.showDetailsChange.emit(true);
        this.worldOpened.emit({ world: this.world, ele: this.worldContainer });
    }

    private closeWorld() {
        // Hide details
        this.showDetails = false;
        this.showDetailsChange.emit(false);
        // Collapse expanded text
        this.maxTextSentences = this.MAX_SENTENCES;
    }

    public readMore() {
        this.maxTextSentences = 100;
        this.cd.detectChanges();
        this.cd.markForCheck();
    }

    public loadClicked(collection: Mote) {
        this.loadWorld.emit({ world: this.world, collection: collection });
        this.cd.detectChanges();
    }
    public playVideo(mote: Mote): void {
        if(!mote || !mote.mediaArray[0] || !mote.mediaArray[0].video) return console.error("no mote or video, mote: ", mote);
        this.playTrailer.emit({ world: this.world, collection: mote })
        //this.videoToPlay = mote.mediaArray[0].video;
    }
}
